import React from 'react';
import Cookies from 'js-cookie';
import 'tailwindcss/tailwind.css';
import crypto from 'crypto';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { Store } from '../../pagepart/store/Store';
import { Env } from '../../env/Env';
import { ServerProps } from '../../pagepart/portal/utils';
import { prismaService } from '../../server/service/PrismaService';

export async function getServerSideProps(rawContext) {
  const { env } = await Env.forNextContext(rawContext);

  const cipher = crypto.createCipher('aes-128-ecb', 'djsk654!!bAEW!h4');
  let passEncrypted: string = cipher.update(env.userEnv.user.password, 'utf-8', 'hex');
  passEncrypted += cipher.final('hex');

  // do not wait for completion
  if (!env.userEnv.user.email.startsWith('gast') && !env.userEnv.user.email.includes('@schlaukopf.')) {
    prismaService.db0.user.updateMany({
      data: { emailVerified: 1, emailFails: 0 },
      where: { email: env.userEnv.user.email },
    });

    // do not wait for completion
    prismaService.db1.user.updateMany({
      data: { emailVerified: 1, emailFails: 0 },
      where: { email: env.userEnv.user.email },
    });
  }

  return {
    props: {
      passEncrypted,
      ...env.transfer,
    },
  };
}

declare const webkit: any;
declare const APP: any;

class AuthDone extends React.Component<ServerProps<typeof getServerSideProps>> {
  @memoize
  get store() {
    return Store.forApp(this);
  }

  setupPage(store: Store) {
    store.portalStore.metaTitle = 'Schlaukopf Modal Return';
  }

  render() {
    const { userData } = this.props;

    return (
      <div style={{ height: '100vH', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>
        <div className="mb-20 rounded-md bg-green-50 p-4" style={{}}>
          <div className="flex" style={{ height: 80, alignItems: 'center', justifyContent: 'center' }}>
            <div className="ml-3">
              <p className="text-sm font-medium text-green-800">
                <p>Du bist jetzt als</p>
                <b>
                  {userData.user.email} - {userData.user.prename}
                </b>{' '}
                <p> angemeldet.</p>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (typeof webkit !== 'undefined' && webkit.messageHandlers && webkit.messageHandlers.receiveUserHandler) {
      try {
        console.log('provide user to android app');
        webkit.messageHandlers.receiveUserHandler.postMessage(
          JSON.stringify({ ...this.props.userData, encrypted: this.props.passEncrypted }),
        );
        return;
      } catch (err) {
        console.log(err);
      }
      return false;
    }
    if (typeof APP !== 'undefined' && APP.receiveUserHandler) {
      try {
        console.log('provide user to ios app');
        APP.receiveUserHandler(JSON.stringify({ ...this.props.userData, encrypted: this.props.passEncrypted }));
        return;
      } catch (err) {
        console.log(err);
      }
      return;
    }

    if (window.name.startsWith('signInPopup') && window.opener && window.opener.window !== window) {
      window.opener.window.location.reload();
      window.close();
      return;
    }

    if (this.store.requestStore.requestData.isInlineViewInWeb && parent && parent.window !== window) {
      parent.location.reload();
      return;
    }

    window.location.pathname = '/';
  }
}

export default AuthDone;
